import { ScrollArea } from '@radix-ui/themes'

export const LeakV0Json = ({ value }: { value: unknown }) => (
  <ScrollArea type="auto" scrollbars="both" className="max-h-64">
    <pre className="text-xs leading-5 text-[var(--gray-11)]">{JSON.stringify(value, null, 2)}</pre>
  </ScrollArea>
)
